import { toast } from 'react-toastify';
import appApi from '../../../../api/app-api';
import { displayErrorText } from '../../../../api/errors/api-error-codes';
import { AccountingJournalReportDetailsEntity } from '../../../../api/types/accounting/journal-entries/accounting-journal-report-details-entity';

export interface GetJournalEntryReportsListPayload {
  offset: number;
  limit: number;
  startDateFrom?: Date | null;
  endDateFrom?: Date | null;
}

// The backend strictly expects `startDateFrom` / `endDateFrom` as `dd/mm/yyyy`
// strings (see Joi `DD_MM_YYYY_PATTERN` on the route). We format on the client
// to avoid a round-trip via the user's locale.
const formatDateAsDdMmYyyy = (date: Date | null | undefined): string | null => {
  if (!date) return null;
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = String(date.getFullYear());
  return `${day}/${month}/${year}`;
};

export const getJournalEntryReportsListOperation = async (
  payload: GetJournalEntryReportsListPayload,
  setData: (data: AccountingJournalReportDetailsEntity[]) => void,
  setTotal: (total: number) => void,
  setLoading: (loading: boolean) => void,
) => {
  try {
    setLoading(true);

    const res = await appApi.getJournalEntryReportsList({
      offset: payload.offset,
      limit: payload.limit,
      startDateFrom: formatDateAsDdMmYyyy(payload.startDateFrom),
      endDateFrom: formatDateAsDdMmYyyy(payload.endDateFrom),
    });

    if (res.data.errCode) {
      toast.warn(displayErrorText(res.data.errCode));
      setLoading(false);
      return;
    }

    const body = res.data.body;
    setData(body?.data ?? []);
    setTotal(body?.total ?? 0);
    setLoading(false);
  } catch (e) {
    toast.error('משהו קרה, יש לנסות שוב בעוד מספר רגעים');
    setLoading(false);
  }
};
